import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=ceb211e8&scoped=true"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=ceb211e8&prod&lang=scss&scoped=true"
import style1 from "./wangeditor.vue?vue&type=style&index=1&id=ceb211e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb211e8",
  null
  
)

export default component.exports